import { Decimal } from 'decimal.js';
import { z } from 'zod';
/** Money held in process, where the amount is still a `Decimal` and safe to do arithmetic on. */
export const MoneySchema = z.object({
    amount: z.instanceof(Decimal),
    currency: z.enum(['USD']),
});
//# sourceMappingURL=money.js.map